import { Examen } from '../../../../models/examen';
import { SelectionModel } from '@angular/cdk/collections';
import { AfterViewInit, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatPaginator, MatSnackBar, MatSort, MatTableDataSource } from '@angular/material';
import * as XLSX from 'xlsx';
import { Router } from '@angular/router';
import { ConduiteService, ExamenChange, ExamenFilters } from '../../../../core/apps/conduite.service';
import { Observable, Subject } from 'rxjs';
import { debounceTime, take, takeUntil } from 'rxjs/operators';
import { AddexamenComponent } from './addexamen/addexamen.component';
import { ViewexamenComponent } from './viewexamen/viewexamen.component';
import { ShowimagesComponent } from './showimages/showimages.component';
import { PDF_CACHET, PDF_CACHET_RATIO } from './pdf-cachet';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
pdfMake.vfs = pdfFonts.pdfMake.vfs;

// Image transparente 1×1 px utilisée comme placeholder quand une image est absente
const PDF_BLANK =
	'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMsAAAAdCAIAAACL/g9WAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAAEnQAABJ0Ad5mH3gAAABdSURBVHhe7dIxAQAADMOg+TfdqcgHGrhByTBahtEyjJZhtAyjZRgtw2gZRsswWobRMoyWYbQMo2UYLcNoGUbLMFqG0TKMlmG0DKNlGC3DaBlGyzBahtEyjJZhlLYHKzy8AOw7gUMAAAAASUVORK5CYII=';

// Logo en-tête du PDF
const PDF_LOGO =
	'data:image/png;base64,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';

@Component({
	selector: 'kt-examen',
	templateUrl: './examen.component.html',
	styleUrls: ['./examen.component.scss'],
})
export class ExamenComponent implements OnInit, AfterViewInit, OnDestroy {

	displayedColumns = [
		'select', 'dateExamen', 'dateReception', 'Entreprise',
		'espece', 'cage', 'ecloserie', 'diagnostic', 'conduite', 'actions',
	];
	selection = new SelectionModel<Examen>(true, []); // sélection multiple : actions groupées (supprimer, exporter)
	actionEnCours = false;

	@ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
	@ViewChild(MatSort, { static: true }) sort: MatSort;

	dataSource: MatTableDataSource<Examen> = new MatTableDataSource([]);
	suggestion: Examen;

	autres = []; entreprises = []; incidents = []; ecloseries = []; especes = [];
	diagnostics = []; parasitaires = []; bacteriologiques = []; conduites = [];
	molecules = []; dureetraitements = [];
	embonpoints = []; revetementcutanes = []; nageoires = []; opercules = [];
	bouches = []; estomacs = []; intestins = []; branchies = []; coeurs = [];
	tetes = []; yeuxs = []; cerveaus = []; rates = []; foies = [];
	vesiculebiliaires = []; reins = []; vessienatatoires = [];

	// Filtres : recherche serveur sur tous les examens (voir ConduiteService.searchExamens)
	filters: ExamenFilters = { date: '', cage: '', entreprise: '', ecloserie: '', diagnostic: '' };
	filterMode = false;
	filterLoading = false;
	filterTruncated = false;
	private readonly FILTER_LIMIT = 100;
	private filterInput$ = new Subject<void>();

	private destroy$ = new Subject<void>();
	private currentPageSize = 15;
	private lastDocSnapshot: any = null;
	private pageCursors: Array<any | null> = [null];

	constructor(private TripService: ConduiteService, public dialog: MatDialog, private router: Router, private snackBar: MatSnackBar) {}

	ngOnInit(): void {
		this.dataSource = new MatTableDataSource([]);
		this.loadExamenPage();
		this.filterInput$.pipe(debounceTime(400), takeUntil(this.destroy$)).subscribe(() => this.runFilter());
		this.TripService.examenChanges$.pipe(takeUntil(this.destroy$)).subscribe(change => this.applyExamenChange(change));
		this.loadLabels(this.TripService.getListautres(), this.autres);
		this.loadLabels(this.TripService.getListparasitaire(), this.parasitaires);
		this.loadLabels(this.TripService.getListbacteriologique(), this.bacteriologiques);
		this.loadLabels(this.TripService.getListdiagnostic(), this.diagnostics);
		this.loadLabels(this.TripService.getListConduite(), this.conduites);
		this.loadLabels(this.TripService.getListEntreprise(), this.entreprises);
		this.loadLabels(this.TripService.getListEspeces(), this.especes);
		this.loadLabels(this.TripService.getListEcloseries(), this.ecloseries);
		this.loadLabels(this.TripService.getListIncidents(), this.incidents);
		this.loadLabels(this.TripService.getListEmbonpoints(), this.embonpoints);
		this.loadLabels(this.TripService.getListRevetementcutane(), this.revetementcutanes);
		this.loadLabels(this.TripService.getListNageoires(), this.nageoires);
		this.loadLabels(this.TripService.getListOpercule(), this.opercules);
		this.loadLabels(this.TripService.getListBouche(), this.bouches);
		this.loadLabels(this.TripService.getListEstomac(), this.estomacs);
		this.loadLabels(this.TripService.getListIntestin(), this.intestins);
		this.loadLabels(this.TripService.getListBranchie(), this.branchies);
		this.loadLabels(this.TripService.getListCoeur(), this.coeurs);
		this.loadLabels(this.TripService.getListTete(), this.tetes);
		this.loadLabels(this.TripService.getListYeux(), this.yeuxs);
		this.loadLabels(this.TripService.getListCerveau(), this.cerveaus);
		this.loadLabels(this.TripService.getListRate(), this.rates);
		this.loadLabels(this.TripService.getListFoie(), this.foies);
		this.loadLabels(this.TripService.getListVesiculebiliaire(), this.vesiculebiliaires);
		this.loadLabels(this.TripService.getListRein(), this.reins);
		this.loadLabels(this.TripService.getListVessienatatoire(), this.vessienatatoires);
		this.loadLabels(this.TripService.getListMolecules(), this.molecules);
		this.loadLabels(this.TripService.getListDureetraitements(), this.dureetraitements);
	}

	ngAfterViewInit(): void {
		this.dataSource.sort = this.sort;
		this.paginator.page.pipe(takeUntil(this.destroy$)).subscribe(event => {
			if (this.filterMode) { return; } // résultats de recherche : pagination locale (MatTableDataSource)
			const pageSizeChanged = event.pageSize !== this.currentPageSize;
			if (pageSizeChanged) {
				this.currentPageSize = event.pageSize;
				this.pageCursors = [null];
				this.lastDocSnapshot = null;
				this.paginator.pageIndex = 0;
				this.loadExamenPage();
				return;
			}
			const targetIndex = event.pageIndex;
			if (this.pageCursors[targetIndex] === undefined) {
				this.pageCursors[targetIndex] = this.lastDocSnapshot;
			}
			this.loadExamenPage(this.pageCursors[targetIndex]);
		});
	}

	ngOnDestroy(): void {
		this.destroy$.next();
		this.destroy$.complete();
	}

	// ── Données ────────────────────────────────────────────────────────────────

	private loadLabels(source$: Observable<any[]>, target: any[]): void {
		source$.pipe(takeUntil(this.destroy$)).subscribe(actions => {
			target.length = 0;
			actions.forEach(a => target.push(
				(a.payload.doc.data() as { libelle: string }).libelle
			));
		});
	}

	private loadExamenPage(cursor: any = null): void {
		this.TripService.getListexamenPage(this.currentPageSize, cursor)
			.pipe(take(1), takeUntil(this.destroy$))
			.subscribe(actions => {
				this.selection.clear(); // nouvelle page : la sélection précédente n'est plus visible
				this.lastDocSnapshot = actions.length > 0
					? actions[actions.length - 1].payload.doc
					: null;
				this.dataSource.data = actions.map(a => ({
					...(a.payload.doc.data() as Examen),
					id: a.payload.doc.id,
				}));
				const hasNextPage = actions.length === this.currentPageSize;
				this.paginator.length = hasNextPage
					? (this.paginator.pageIndex + 2) * this.currentPageSize
					: (this.paginator.pageIndex + 1) * this.currentPageSize;
			});
	}

	// ── Sélection ──────────────────────────────────────────────────────────────

	isAllSelected(): boolean {
		return this.selection.selected.length === this.dataSource.data.length;
	}

	masterToggle(): void {
		this.isAllSelected()
			? this.selection.clear()
			: this.dataSource.data.forEach(row => this.selection.select(row));
	}

	// ── Actions groupées sur la sélection ─────────────────────────

	/** Supprime les examens cochés (et leurs photos) après confirmation. */
	async supprimerSelection(): Promise<void> {
		const lignes = this.selection.selected.slice();
		if (!lignes.length || this.actionEnCours) {
			return;
		}
		if (!window.confirm(`Supprimer ${lignes.length} examen(s) et leurs photos ?\nCette action est définitive.`)) {
			return;
		}
		this.actionEnCours = true;
		let supprimes = 0;
		for (const ligne of lignes) {
			try {
				await this.TripService.deleteExamen(ligne.id, ligne);
				supprimes++;
			} catch (e) {
				console.error('Suppression impossible', ligne.id, e);
			}
		}
		this.selection.clear();
		this.actionEnCours = false;
		const echecs = lignes.length - supprimes;
		this.snackBar.open(`${supprimes} examen(s) supprimé(s)` + (echecs ? `, ${echecs} échec(s)` : ''), 'OK', { duration: 6000 });
	}

	/** Exporte en Excel uniquement les examens cochés. */
	exporterSelection(): void {
		const liste = (v: any) => Array.isArray(v) ? v.join(' ; ') : (v || '');
		const lignes = this.selection.selected.map((e: any) => ({
			'Date examen': e.dateExamen, 'Date réception': e.dateRecepetion, 'Entreprise': e.entreprise, 'Espèce': e.espece,
			'N° cage': e.numCage, 'Ecloserie': e.ecloserie, 'T° eau': e.tempEau, 'PM (g)': e.pm,
			'Mortalité totale': e.totalMortalite, 'Diagnostic': liste(e.diagnosticobservation), 'Conduite à tenir': liste(e.conduiteobservation),
		}));
		const classeur = XLSX.utils.book_new();
		XLSX.utils.book_append_sheet(classeur, XLSX.utils.json_to_sheet(lignes), 'Examens');
		XLSX.writeFile(classeur, 'Examens-selection.xlsx');
	}

	// ── Filtres ────────────────────────────────────────────────────────────────

	onFilterChange(): void {
		this.filterInput$.next();
	}

	get hasActiveFilter(): boolean {
		// lisible avant ngOnInit (ngrx parcourt les objets en dev) : ne pas supposer `filters` défini
		return Object.keys(this.filters || {}).some(k => !!String(this.filters[k] || '').trim());
	}

	clearFilters(): void {
		this.filters = { date: '', cage: '', entreprise: '', ecloserie: '', diagnostic: '' };
		this.runFilter();
	}

	private matchesFilters(e: any): boolean {
		const f = this.filters;
		const t = (v: string) => String(v || '').trim();
		const starts = (value: any, prefix: string) => !t(prefix) || String(value || '').indexOf(t(prefix)) === 0;
		return starts(e.numCage, f.cage) && starts(e.entreprise, f.entreprise) && starts(e.ecloserie, f.ecloserie) &&
			(!t(f.date) || e.dateExamen === t(f.date)) &&
			(!t(f.diagnostic) || (Array.isArray(e.diagnosticobservation) && e.diagnosticobservation.indexOf(t(f.diagnostic)) !== -1));
	}

	private runFilter(): void {
		this.selection.clear();
		if (!this.hasActiveFilter) {
			// Retour à la liste paginée normale (première page)
			this.filterMode = false;
			this.filterTruncated = false;
			this.dataSource.paginator = null;
			this.pageCursors = [null];
			this.lastDocSnapshot = null;
			this.paginator.pageIndex = 0;
			this.loadExamenPage();
			return;
		}
		this.filterLoading = true;
		this.TripService.searchExamens(this.filters, this.FILTER_LIMIT)
			.pipe(take(1), takeUntil(this.destroy$))
			.subscribe(rows => {
				this.filterMode = true;
				this.filterTruncated = rows.length >= this.FILTER_LIMIT;
				this.dataSource.paginator = this.paginator;
				this.dataSource.data = rows.filter(e => this.matchesFilters(e));
				this.paginator.firstPage();
				this.filterLoading = false;
			}, () => { this.filterLoading = false; });
	}

	// ── Dialogs ────────────────────────────────────────────────────────────────

	private buildDialogData(examen: any, listType: string): any {
		return {
			examen, list: listType,
			autres: this.autres, diagnostics: this.diagnostics, conduites: this.conduites,
			bacteriologiques: this.bacteriologiques, parasitaires: this.parasitaires,
			entreprises: this.entreprises, especes: this.especes, ecloseries: this.ecloseries,
			incidents: this.incidents, embonpoints: this.embonpoints,
			revetementcutanes: this.revetementcutanes, nageoires: this.nageoires,
			opercules: this.opercules, bouches: this.bouches, estomacs: this.estomacs,
			intestins: this.intestins, branchies: this.branchies, coeurs: this.coeurs,
			yeuxs: this.yeuxs, cerveaus: this.cerveaus, rates: this.rates,
			foies: this.foies, vesiculebiliaires: this.vesiculebiliaires,
			reins: this.reins, vessienatatoires: this.vessienatatoires, tetes: this.tetes,
			molecules: this.molecules, dureetraitements: this.dureetraitements,
		};
	}

	openDialogParcelle(examen: any): void {
		this.dialog.open(AddexamenComponent, {
			width: '900px',
			data: this.buildDialogData(examen, 'add'),
		});
	}

	modifierDialog(examen: any): void {
		this.dialog.open(AddexamenComponent, {
			width: '900px',
			data: { id: examen.id, ...this.buildDialogData(examen, 'update') },
		});
	}

	deleteDialog(conduite: any): void {
		this.dialog.open(AddexamenComponent, {
			width: '600px',
			data: { id: conduite.id, list: 'delete' },
		});
	}

	private applyExamenChange(change: ExamenChange): void {
		const data = [...this.dataSource.data];
		switch (change.action) {
			case 'add':
				data.unshift(change.examen);
				break;
			case 'update': {
				const idx = data.findIndex(e => e.id === change.examen.id);
				if (idx > -1) { data[idx] = change.examen; }
				break;
			}
			case 'delete': {
				const idx = data.findIndex(e => e.id === change.id);
				if (idx > -1) { data.splice(idx, 1); }
				break;
			}
		}
		this.dataSource.data = data;
	}

	pdfDialog(conduite: any): void {
		this.dialog.open(ViewexamenComponent, {
			width: '800px',
			data: { id: conduite.id, examen: conduite, list: 'delete' },
		});
	}

	/** Ouvre le formulaire d'ordonnance pré-rempli avec ferme, cage, température et durée de l'examen. */
	ordonnanceDepuisExamen(examen: any): void {
		// Le module des pages est monté sous /dashboard (app-routing)
		this.router.navigate(['/dashboard/ordenance'], { queryParams: { examen: examen.id } });
	}

	imgDialog(conduite: any): void {
		this.dialog.open(ShowimagesComponent, {
			width: '800px',
			data: { id: conduite.id, examen: conduite },
		});
	}

	// ── Génération PDF ─────────────────────────────────────────────────────────

	pdfDialog2(selection: any, avecCachet: boolean): void {
		this.suggestion = Object.assign(new Examen(), selection);
		pdfMake.createPdf(this.buildPdfDocDef(avecCachet)).download(
			`Examen anatomo-pathologique / date:${this.suggestion.dateRecepetion}` +
			` Cage: ${this.suggestion.numCage}` +
			` Entreprise: ${this.suggestion.entreprise}`
		);
	}

	/** Plusieurs observations : une par ligne avec une puce ; une seule : sans puce. */
	private observationsText(obs: any): string {
		if (!Array.isArray(obs)) {
			return String(obs || '');
		}
		const items = obs.map(o => String(o || '').trim()).filter(o => !!o);
		return items.length > 1 ? items.map(o => '• ' + o).join('\n') : items.join('');
	}

	private organeText(obs: any, input: string): string {
		const o = this.observationsText(obs);
		const i = String(input || '');
		return o + (o && i ? '\n' : '') + i;
	}

	private organeRow(label: string, obs: any, input: string, freq: string, sev: string): any[] {
		return [
			{ text: label, bold: true },
			this.organeText(obs, input),
			String(freq || ''),
			String(sev || ''),
		];
	}

	private organeTable(rows: any[][]): any {
		return {
			table: {
				headerRows: 1,
				widths: [100, 250, 75, 75],
				body: [
					[
						{ text: '', bold: true },
						{ text: 'Observation', bold: true },
						{ text: 'Fréquence', bold: true },
						{ text: 'Sévérité', bold: true },
					],
					...rows,
				],
			},
		};
	}

	private pdfImage(base64: string): any {
		if (!base64) {
			return { image: PDF_BLANK, alignment: 'center', width: 1, height: 1 };
		}
		const imageData = base64.startsWith('data:') ? base64 : `data:image/jpeg;base64,${base64}`;
		return { image: imageData, alignment: 'center', fit: [550, 550] };
	}

	// Cachet posé sous « Signature et Cachet du vétérinaire », aligné à droite ; unbreakable pour ne pas le couper entre deux pages
	private pdfCachet(): any {
		const width = 220;
		return {
			stack: [
				{ text: ' ' },
				{ image: PDF_CACHET, width, height: width / PDF_CACHET_RATIO, alignment: 'right' },
			],
			unbreakable: true,
		};
	}

	private buildPdfDocDef(avecCachet: boolean): any {
		const s = this.suggestion;

		const externalExamRows = [
			this.organeRow("Etat d’embonpoint",   s.embonpointobservation,        s.embonpointobservationinput,        s.embonpointfrequence,        s.embonpointseverite),
			this.organeRow('Revêtement cutané',        s.revetementobservation,         s.revetementobservationinput,         s.revetementfrequence,         s.revetementseverite),
			this.organeRow('Nageoires',                s.nageoiresobservation,           s.nageoiresobservationinput,           s.nageoiresfrequence,           s.nageoiresseverite),
			this.organeRow('Opercule',                 s.operculeobservation,            s.operculeobservationinput,            s.operculefrequence,            s.operculeseverite),
		];

		const internalExamRows = [
			this.organeRow('Bouche',           s.boucheobservation,           s.boucheobservationinput,           s.bouchefrequence,           s.boucheseverite),
			this.organeRow('Estomac',          s.estomacobservation,          s.estomacobservationinput,          s.estomacfrequence,          s.estomacseverite),
			this.organeRow('Intestin',         s.intestinobservation,         s.intestinobservationinput,         s.intestinfrequence,         s.intestinseverite),
			this.organeRow('Branchie',         s.branchieobservation,         s.branchieobservationinput,         s.branchiefrequence,         s.branchieseverite),
			this.organeRow('Cœur',             s.coeurobservation,            s.coeurobservationinput,            s.coeurfrequence,            s.coeurseverite),
			this.organeRow('Tête',             s.teteobservation,             s.teteobservationinput,             s.tetefrequence,             s.teteseverite),
			this.organeRow('Yeux',             s.yeuxobservation,             s.yeuxobservationinput,             s.yeuxfrequence,             s.yeuxseverite),
			this.organeRow('Cerveau',          s.cerveauobservation,          s.cerveauobservationinput,          s.cerveaufrequence,          s.cerveauseverite),
			this.organeRow('Rate',             s.rateobservation,             s.rateobservationinput,             s.ratefrequence,             s.rateseverite),
			this.organeRow('Foie',             s.foieobservation,             s.foieobservationinput,             s.foiefrequence,             s.foieseverite),
			this.organeRow('Vésicule biliaire',s.vesiculeBiliaireobservation, s.vesiculeBiliaireobservationinput, s.vesiculeBiliairefrequence, s.vesiculeBiliaireseverite),
			this.organeRow('Rein',             s.reinobservation,             s.reinobservationinput,             s.reinfrequence,             s.reinseverite),
			this.organeRow('Vessie natatoire', s.vessienatatoireobservation,  s.vessienatatoireobservationinput,  s.vessienatatoirefrequence,  s.vessienatatoireseverite),
			this.organeRow('Autres',           s.autresobservation,           s.autresobservationinput,           s.autresfrequence,           s.autresseverite),
		];

		return {
			footer: (currentPage: number, pageCount: number) => ({
				text: `${currentPage} / ${pageCount}`,
				alignment: 'right',
				margin: [0, 0, 20, 0],
			}),
			header: () => ({
				columns: [
					{ text: 'Docteur Gall Mejdi',  alignment: 'left',   margin: [30, 20, 15, 30] },
					{ image: PDF_LOGO,              width: 50,           alignment: 'center' },
					{ text: 'Médecin vétérinaire', alignment: 'right',  margin: [30, 20, 15, 30] },
				],
			}),
			content: [
				{ text: 'Examen anatomo-pathologique', bold: true, alignment: 'center', fontSize: 20 },
				{ text: ' ' },
				{
					table: {
						headerRows: 1, widths: [200, 300],
						body: [
							[{ text: 'Date', bold: true }, s.dateExamen],
							[{ text: 'Société :', bold: true }, s.entreprise],
						],
					},
				},
				{ text: ' ' },
				{ text: 'Commémoratifs :', bold: true },
				{
					table: {
						headerRows: 1, widths: [200, 300],
						body: [
							[{ text: 'N° cage :', bold: true },                          s.numCage],
							[{ text: 'Espèce :', bold: true },                           s.espece],
							[{ text: "Ecloserie d’origine :", bold: true },          s.ecloserie],
							[{ text: "T° de l’eau (°C) :", bold: true },            s.tempEau],
							[{ text: "Date réception échantillons :", bold: true },      s.dateRecepetion],
						],
					},
				},
				{ text: ' ' },
				{ text: 'Anamnèse :', bold: true },
				{
					table: {
						headerRows: 1, widths: [200, 300],
						body: [
							[{ text: 'PM (g) :', bold: true },                                           s.pm],
							[{ text: 'Mortalité par jour :', bold: true },                               s.mortaliteparjours],
							[{ text: 'Nombre de jours de mortalité :', bold: true },                     s.nbrJoursMortalite],
							[{ text: 'Mortalité totale :', bold: true },                                 s.totalMortalite],
							[{ text: 'Incidents déclenchant / Motif de consultation :', bold: true },    s.incident],
						],
					},
				},
				{ text: ' ' },
				{ text: "A l’autopsie :", bold: true },
				{ text: 'I / Examen externe :', bold: true },
				this.organeTable(externalExamRows),
				{ text: ' ' },
				{ text: 'II / Examen interne :', bold: true },
				this.organeTable(internalExamRows),
				{ text: ' ' },
				{ text: 'Recherche parasitaire :', bold: true },
				{
					table: {
						headerRows: 1, widths: [200, 150, 150],
						body: [
							[{ text: 'Observation', bold: true }, { text: '', bold: true }, { text: 'Forme' }],
							[s.rechercheparasitaireobservation, s.parasitaire, s.rechercheparasitaireforme],
						],
					},
				},
				{ text: ' ' },
				{ text: 'Recherche bactériologique :', bold: true },
				{
					table: {
						headerRows: 1, widths: [200, 150, 150],
						body: [
							[{ text: 'Observation', bold: true }, { text: '', bold: true }, { text: 'Forme' }],
							[s.recherchebacteriologiqueobservation, s.bacteriologique, s.recherchebacteriologiqueforme],
						],
					},
				},
				{ text: ' ' },
				{ text: 'Diagnostic de suspicion :', bold: true },
				{
					table: {
						headerRows: 1, widths: [200, 150, 150],
						body: [
							[s.diagnosticdiagnostictexte, s.diagnosticobservation, s.diagnosticforme],
						],
					},
				},
				{ text: ' ' },
				{ text: 'Conduite à tenir :', bold: true },
				{
					table: {
						headerRows: 1, widths: [200, 100, 100, 100],
						body: [
							[
								{ text: 'Observation', bold: true }, { text: '', bold: true },
								{ text: 'Molécule', bold: true }, { text: 'Durée traitement', bold: true },
							],
							[s.conduiteobservation, s.conduiteconduitetexte, s.conduitemolecule, s.conduitedurretraitement],
						],
					},
				},
				{ text: ' ' },
				{ text: ' ' },
				{ text: 'Signature et Cachet du vétérinaire', alignment: 'right', keepWithNext: true },
				...(avecCachet ? [this.pdfCachet()] : []),
				{ text: ' ' },
				this.pdfImage(s.imageurlconvert),
				{ text: ' ' },
				this.pdfImage(s.imageurlconvert1),
				{ text: ' ' },
				this.pdfImage(s.imageurlconvert2),
				{ text: ' ' },
				this.pdfImage(s.imageurlconvert3),
				{ text: ' ' },
				this.pdfImage(s.imageurlconvert4),
			],
		};
	}
}
